import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable, empty } from 'rxjs';
import { IControlNameBody, ILanguageTranslation, BaseResponse } from '../models';
import { ApiService } from './api.service';
import { ConfigService } from './config.service';
import { catchError, map } from 'rxjs/operators';
@Injectable({
  providedIn: 'root'
})
export class KawneerAdminService {

  constructor(private httpClient: HttpClient
    ) { }
  public getLanguageTranslation(languageCode: string): Observable<ILanguageTranslation[]> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.KAWNEER_ADMIN.GET_LANGUAGE_TRANSLATION}/${languageCode}`;
    return ApiService.genericObservableGet(this.httpClient, apiEndpoint).pipe(
      catchError((err, caught) => { console.log(err); console.log(caught); return empty(); }),
      map((response: BaseResponse) => response.data)
    );
  }
  public saveControlName(body: IControlNameBody): Observable<ILanguageTranslation> {
    const apiEndpoint = `${ConfigService.APIs.endPoints.KAWNEER_ADMIN.SAVE_CONTROL_NAME}`;
    return ApiService.genericObservablePost(this.httpClient, apiEndpoint,body);
  }
}
